import React, { Suspense, useContext } from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import ChangeLogView from '../../Views/shared/ChangeLogView'
import InstitutionEvaluationSummaryView from '../../Views/institution/InstitutionEvaluationSummaryView'
import InstitutionProvider from '../../Providers/InstitutionProvider'
import InstitutionGroupProvider from '../../Providers/InstitutionGroupProvider'
import SchoolsView from '../../Views/institutionGroup/SchoolsView/SchoolsView'
import InstitutionsView from '../../Views/institutionGroup/InstitutionsView/InstitutionsView'
import SectorsView from '../../Views/school/validator/SectorsView'
import MaccsProfilePage from '../../Components/MACCS/ProfilePage/MaccsProfilePage'
import InstitutionGroupSettingsView from '../../Views/MACCS/InstitutionGroupSettings/InstitutionGroupSettingsView'
import ReportingView from '../../Views/MACCS/ReportingView/ReportingView'
import { Routes } from '../../routes'
import AssistantsView from '../../Views/MACCS/Assistants/AssistantsView'
import MaccsInternshipsProvider from '../../Providers/MaccsInternshipsProvider'
import MaccsInternshipsCalendar from '../../Views/MACCS/MaccsInternshipsManager/MaccsInternshipsCalendar'
import { isMoment } from 'moment'
import { GlobalContext } from '../../Providers/GlobalProvider'
import MaccsInternshipMessageProvider from '../../Providers/MaccsinternshipMessageProvider'

const MaccsInstitutionGroupAdminRouter = ({ history, onLogout }) => {
  const { setCurrentDate } = useContext(GlobalContext)

  const goToShiftManager = date => {
    history.push(Routes.SHIFTS_MANAGER)

    if (isMoment(date)) {
      setCurrentDate(date)
    }
  }
  return (
    <InstitutionProvider>
      <InstitutionGroupProvider>
        <MaccsInternshipMessageProvider>
          <Switch>
            <Route path={Routes.INTERNSHIPS}>
              <MaccsInternshipsProvider>
                <MaccsInternshipsCalendar loadShiftsManager={goToShiftManager} />
              </MaccsInternshipsProvider>
            </Route>
            <Route path={Routes.STUDENTS}>
              <AssistantsView />
            </Route>
            <Route path={Routes.SETTINGS}>
              <InstitutionGroupSettingsView />
            </Route>
            <Route path={Routes.BADGES}>
              <ReportingView />
            </Route>
            <Route path={Routes.SCHOOLS}>
              <SchoolsView />
            </Route>
            <Route path={Routes.INSTITUTIONS}>
              <InstitutionsView />
            </Route>
            <Route path={Routes.INSTITUTION_SECTORS}>
              <SectorsView />
            </Route>
            <Route path={Routes.CHANGELOG}>
              <ChangeLogView />
            </Route>
            <Route path={Routes.PROFILE_PAGE}>
              <MaccsProfilePage onLogout={onLogout} />
            </Route>
            <Route path={Routes.STUDENTS_EVALUATION}>
              <Suspense fallback={<div>Loading...</div>}>
                <InstitutionEvaluationSummaryView />
              </Suspense>
            </Route>
          </Switch>
        </MaccsInternshipMessageProvider>
      </InstitutionGroupProvider>
    </InstitutionProvider>
  )
}

export default withRouter(MaccsInstitutionGroupAdminRouter)
